import React from "react";
import "./PackageInfo.css";
import { useParams } from "react-router-dom";
import PaintCorrection from "./PaintCorrection";
import Exterior from "./Exterior";
import Interior from "./Interior";
function PackageInfo() {
  var packageInfo = useParams();
  console.log(packageInfo);

  return (
    <div>
      {packageInfo.package === "paint correction" ? <PaintCorrection /> : null}
      {packageInfo.package === "exterior" ? <Exterior /> : null}
      {packageInfo.package === "interior" ? <Interior /> : null}
    </div>
  );
}

export default PackageInfo;
